import type RibbonFormatState from '../store/schema/RibbonFormatState';
import type { EditorViewState } from 'owa-editor';
import { action, mutator, orchestrator } from 'satcheljs';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';

import FORMATPAINTERCURSOR_SVG from './formatpaintercursor.svg';
const FORMATPAINTERCURSOR_STYLE = `;cursor: url("${FORMATPAINTERCURSOR_SVG}") 8.5 16, auto`;
const CURSOR_REGEX = /;?\s*cursor:\s*url\(\".*?\"\)[^;]*/gi;

const toggleFormatPainter = action(
    'toggleFormatPainter',
    (
        editorViewState: EditorViewState,
        ribbonFormatState: RibbonFormatState,
        isFormatPainterOn: boolean
    ) => ({ editorViewState, ribbonFormatState, isFormatPainterOn })
);

export default toggleFormatPainter;

mutator(toggleFormatPainter, actionMessage => {
    const { editorViewState, ribbonFormatState, isFormatPainterOn } = actionMessage;
    ribbonFormatState.formatPainterFormat = isFormatPainterOn
        ? callFormatApi(editorViewState, 'getFormatState')
        : null;
});

orchestrator(toggleFormatPainter, actionMessage => {
    const { editorViewState, isFormatPainterOn } = actionMessage;
    let styles = callEditorApi(editorViewState, 'getEditorDomAttribute', 'style') || '';
    styles = styles.replace(CURSOR_REGEX, '');

    if (isFormatPainterOn) {
        styles += FORMATPAINTERCURSOR_STYLE;
    }
    callEditorApi(editorViewState, 'setEditorDomAttribute', 'style', styles);
});
